module.exports = __webpack_public_path__ + "static/media/ic_head12.69d6e8d0.png";